
import React from 'react';
import { Droplet } from 'lucide-react';

const WaterFlowRateKpi = () => {
  return (
    <div className="h-full flex items-center justify-center">
      <div className="p-4 flex flex-col items-center justify-center h-full w-full">
        <h3 className="text-lg font-medium text-gray-800 dark:text-white mb-2">Peak Flow Rate</h3>
        <div className="mb-2">
          <Droplet className="h-7 w-7 text-blue-500 mb-2" />
        </div>
        <p className="text-xl font-bold text-blue-500 mb-2">3.8 m³/h</p>
        <p className="text-xs text-gray-500 dark:text-gray-300">Average peak time: 07:30</p>
      </div>
    </div>
  );
};

export default WaterFlowRateKpi;
